import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AprobacionMasivaService } from 'src/app/services/aprobacion-masiva.service';
import { EventNavbarService } from 'src/app/services/event-navbar.service';
import { NavigationService } from '../../services/navigation.service';
import { CANTIDAD_MINIMA } from 'src/app/utils/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationService } from '../../services/validation.service';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from "@angular/forms";
import { EvidenciaService } from '../../services/evidencia.service';
import { saveAs } from 'file-saver';
import { CapacitacionService } from "../../services/capacitacion.service";
import { LoginService } from '../../services/login.service';
export class CustomAdapter extends NgbDateAdapter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '-';
    }
    fromModel(value) {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }
    toModel(date) {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
    }
}
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '/';
    }
    parse(value) {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }
    format(date) {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
    }
}
export class AprobacionMasivaComponent {
    constructor(navigationService, aprobacionService, eventNavbarService, modalService, validationService, evidenciaService, fb, capacitaciones, loginService) {
        this.navigationService = navigationService;
        this.aprobacionService = aprobacionService;
        this.eventNavbarService = eventNavbarService;
        this.modalService = modalService;
        this.validationService = validationService;
        this.evidenciaService = evidenciaService;
        this.fb = fb;
        this.capacitaciones = capacitaciones;
        this.loginService = loginService;
        this.accion = '';
        this.orderHeader = '';
        this.reverse = false;
        this.planIdHabilitado = false;
        this.planHabilitado = false;
        this.capacitacionHabilitado = false;
        this.contratistaHabilitado = false;
        this.zonaHabilitado = false;
        this.categoriaHabilitado = false;
        this.focoHabilitado = false;
        this.enfoqueHabilitado = false;
        this.ejecutorHabilitado = false;
        this.fechaHabilitado = false;
        this.isKpiCollapsed = false;
        this.cantidadMinimaCaps = CANTIDAD_MINIMA;
        //Mantenedores
        this.listaAnio = [];
        this.listaEmpresa = [];
        this.listaPlan = [];
        //Lista Capacitaciones
        this.listaCapacitaciones = [];
        this.listaRechazados = [];
        this.listaKpi = [];
        this.listRefuerzo = [];
        this.listRefuerzoAreas = [];
        this.listStatus = [];
        this.estado = {};
        //Obtención Mantenedores
        this.anioSelected = 0;
        this.tipoCapacitacionSelected = null;
        this.empresaSelected = null;
        this.estadoSelected = null;
        this.planSelected = null;
        this.idPlanSelected = 0;
        this.observacionRechazo = null;
        this.observacionCancelacion = null;
        //Escritura Mensaje
        this.mensaje = "";
        //Manejo Selectd
        this.habilitarBusqueda = false;
        this.habilitarAprobacion = false;
        this.habilitarIconos = false;
        this.habilitarRechazo = false;
        this.habilitarTabla = false;
        this.habilitarRechazados = false;
        this.habilitarAcciones = false;
        this.habilitarKpi = false;
        this.empresaVisible = false;
        this.estadoVisible = false;
        this.planVisible = false;
        this.estados = [{ id: 2, value: 'Enviada para aprobación' }, { id: 3, value: 'Aprobada' }, { id: 4, value: 'Rechazada' }];
        this.meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        this.pageActual = 1;
        //Valores Modal Capacitacion
        this.cancCapacitacionId = 0;
        this.modCapacitacionId = 0;
        this.modNombreCapacitacion = "";
        this.modIdPlan = "";
        this.modPlanCapacitacion = "";
        this.modNombreContratista = "";
        this.modZona = "";
        this.modCategoria = "";
        this.modFoco = "";
        this.modEnfoque = "";
        this.modEjecutor = "";
        this.modFecha = "";
        this.modHH = "";
        this.modParticipantes = "";
        this.errorMessage = "";
        this.realAssistance = 0;
        this.workersIdSelected = [];
        this.workersSelected = [];
        this.workersColumns = [
            'Rut Trabajador',
            'Nombre',
            'Apellido Paterno',
            'Apellido Materno'
        ];
        this.workersRows = [];
        this.uuid = "";
        this.idsAdjuntos = [];
        this.evidences = [];
        this.listClass = false;
        this.horaCapacitacion = "";
        this.listAdjuntos = [];
        this.existenCapacitaciones = false;
        this.porcentajeMinimodeAprobacion = 0;
        this.aprobarIcon = false;
        this.rechazarIcon = false;
        this.iconBtnBuscarCapacitacion = false;
        this.form = this.fb.group({
            evidenceFile: [null]
        });
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('revisionPlanes').then((response) => {
                this.rolid = response.data.rolId;
                console.log('Pantalla Aprobacion');
                console.log(this.rolid);
            });
            $("#show-loading").css('display', 'grid');
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'));
            this.error = false;
            this.errorModal = false;
            this.exitoInsercion = false;
            this.rechazoInsercion = false;
            this.openNavbar();
            this.getAnnio();
            this.tipoCapacitacionSelected = "reforzamiento";
            if (!this.navigationService.getValidLogin()) {
                this.navigationService.goTo('/login');
            }
        });
    }
    openNavbar() {
        this.eventNavbarService.openNavbar();
    }
    clickMethod(name) {
        if (confirm("Are you sure to delete " + name)) {
            console.log("Implement delete functionality here");
        }
    }
    //Filtros de Búsqueda
    //Filtros : Find Año
    getAnnio() {
        this.aprobacionService.getAnnio()
            .then(response => {
            this.listaAnio = response;
            this.onAnioChange(this.listaAnio[0], true);
            $("#show-loading").css('display', 'none');
            if (this.listaAnio.length == 0) {
                this.existenCapacitaciones = false;
            }
            else {
                this.existenCapacitaciones = true;
            }
        })
            .catch(error => {
            error = true;
            $("#show-loading").css('display', 'none');
        });
    }
    //Filtros : Find empresa
    getEmpresa() {
        if (this.anioSelected == undefined)
            this.anioSelected = 0;
        this.aprobacionService.getEmpresa(this.anioSelected, parseInt(sessionStorage.getItem('userid')), this.rolid)
            .then(response => {
            this.listaEmpresa = response;
            this.onEmpresaChange(this.listaEmpresa, true);
        })
            .catch(error => {
            error = true;
        });
    }
    //Filtros : Find plan
    getPlanCapacitacion() {
        this.aprobacionService.getPlanCapacitacion(this.anioSelected, this.empresaSelected, this.estadoSelected, parseInt(sessionStorage.getItem('userid')), this.rolid)
            .then(response => {
            this.listaPlan = response;
        })
            .catch(error => {
            error = true;
        });
    }
    //Cambio de opción - Select Año
    onAnioChange(event, interno) {
        if (interno) {
            this.anioSelected = event;
        }
        else {
            this.anioSelected = event.target.value;
        }
        this.onTipoCapacitacionChange("plan", true);
        if (this.rolid == 1 || this.rolid == 2) {
            this.getEmpresa();
            this.empresaVisible = true;
        }
        else {
            this.estadoVisible = true;
            this.onEstadoChange(null, true);
        }
    }
    //Cambio de opción - Select Empresa
    onEmpresaChange(event, interno) {
        ;
        if (interno) {
            this.empresaSelected = event[0].capacitacionId;
        }
        else {
            this.empresaSelected = event.target.value;
        }
        if (this.empresaSelected !== null) {
            this.estadoVisible = true;
            this.onEstadoChange(null, true);
        }
        else {
            this.planSelected = null;
            this.estadoVisible = false;
            this.habilitarBusqueda = false;
        }
    }
    onTipoCapacitacionChange(event, interno) {
        if (interno) {
            this.tipoCapacitacionSelected = event;
        }
        else {
            this.tipoCapacitacionSelected = event.target.value;
        }
        if (this.tipoCapacitacionSelected === "reforzamiento") {
            this.onEstadoChange(null, true);
            this.onPlanChange(0, true);
        }
    }
    //Cambio de opción - Select Estado
    onEstadoChange(event, interno) {
        this.habilitarBusqueda = true;
        if (interno) {
            this.estadoSelected = this.estados[0].id;
        }
        else {
            this.estadoSelected = event.target.value;
        }
        if (this.rolid == 1 || this.rolid == 2) {
            this.planVisible = true;
            this.onPlanChange(0, true);
            this.getPlanCapacitacion();
        }
    }
    //Cambio de opción - Select Plan
    onPlanChange(event, interno) {
        if (interno) {
            this.idPlanSelected = event;
        }
        else {
            let plan = event.target.value.split(",");
            this.idPlanSelected = plan[0];
        }
    }
    //Cambio Estado Plan
    cambioEstadoPlan(accion) {
        //asdasdasd
        $("#buttonAprobar").prop("disabled", true);
        $("#buttonRechazar").prop("disabled", true);
        this.aprobacionService.cambioEstadoPlan(this.idPlanSelected, accion, this.observacionRechazo, sessionStorage.getItem('userid'))
            .then(response => {
            $("#buttonAprobar").prop("disabled", false);
            $("#buttonRechazar").prop("disabled", false);
            this.aprobarIcon = false;
            this.rechazarIcon = false;
            this.listaCapacitaciones = [];
            this.anioSelected = null;
            this.empresaSelected = null;
            this.planSelected = null;
            this.mensaje = response;
            if (this.mensaje.includes("aprobó")) {
                this.rechazoInsercion = false;
                this.exitoInsercion = true;
            }
            else {
                this.rechazoInsercion = true;
            }
            this.habilitarTabla = false;
            this.observacionRechazo === null;
            this.getAnnio();
        })
            .catch(error => {
            this.aprobarIcon = false;
            this.rechazarIcon = false;
            $("#buttonAprobar").prop("disabled", false);
            $("#buttonRechazar").prop("disabled", false);
            this.error = true;
            this.mensaje = "Ha ocurrido un error en la inserción, comuniquese con el administrador";
        });
    }
    //Botón buscar Capacitaciones
    buscarCapacitacionesFiltradas() {
        $("#btnBuscarCapacitacion").prop("disabled", true);
        this.iconBtnBuscarCapacitacion = true;
        this.listaCapacitaciones = [];
        let tipoCapacitacion = this.tipoCapacitacionSelected === "plan" ? 1 : 2;
        if (this.rolid == 1 || this.rolid == 2) {
            let plan = this.idPlanSelected == 0 ? "TODOS" : String(this.idPlanSelected);
            this.getListaCapacitacionesAdmin(this.anioSelected, this.estadoSelected, this.empresaSelected, plan, tipoCapacitacion);
        }
        else {
            this.getListaCapacitaciones(this.anioSelected, this.estadoSelected, this.loginData.usertableentity.empresa.idEmpresa, tipoCapacitacion);
        }
        this.habilitarTabla = true;
        this.estadoSelected === 3 ? this.habilitarIconos = true : this.habilitarIconos = false;
        if (this.estadoSelected === 2 && this.idPlanSelected !== 0) {
            this.buscarKpiCumplimiento(this.idPlanSelected);
            this.buscarReforzamiento(this.idPlanSelected);
            this.habilitarAprobacion = true;
            this.habilitarRechazo = true;
            this.habilitarKpi = true;
            this.habilitarAcciones = false;
        }
        else {
            this.habilitarAprobacion = false;
            this.habilitarRechazo = false;
            this.habilitarKpi = false;
            if ((this.rolid == 1 || this.rolid == 2) && this.estadoSelected === 4 && this.idPlanSelected !== 0) {
                this.habilitarRechazados = true;
            }
            else if (this.rolid == 3 && this.estadoSelected === 4) {
                this.habilitarRechazados = true;
            }
            else {
                this.habilitarRechazados = false;
            }
            if (this.estadoSelected === 3 && this.idPlanSelected !== 0) {
                this.habilitarAcciones = true;
            }
            else if (this.rolid == 3 && this.estadoSelected === 3) {
                this.habilitarAcciones = false;
            }
            else {
                this.habilitarAcciones = false;
            }
            $("#btnBuscarCapacitacion").prop("disabled", false);
            this.iconBtnBuscarCapacitacion = false;
        }
    }
    //Metodo de búsqueda de capacitaciones - Perfil Contratista
    getListaCapacitaciones(anio, estado, empresa, tipoCapacitacion) {
        this.listaCapacitaciones = [];
        this.aprobacionService.getListaCapacitacionesContratista(anio, estado, empresa, tipoCapacitacion)
            .then(response => {
            let resp = response;
            this.listaRechazados = resp.observacion;
            this.listaCapacitaciones = resp.listaCapacitaciones;
        })
            .catch(error => {
            error = true;
        });
    }
    //Metodo de búsqueda de capacitaciones - Perfil Administrador
    getListaCapacitacionesAdmin(anio, estado, empresa, plan, tipoCapacitacion) {
        this.listaCapacitaciones = [];
        this.aprobacionService.getListaCapacitacionesAdmin(anio, estado, empresa, plan, tipoCapacitacion)
            .then(response => {
            let resp = response;
            this.listaRechazados = resp.observacion;
            this.listaCapacitaciones = resp.listaCapacitaciones;
        })
            .catch(error => {
            error = true;
        });
    }
    //Evaluación de KPI
    buscarKpiCumplimiento(idPlan) {
        this.aprobacionService.buscarKpiCumplimiento(idPlan)
            .then(response => {
            let resp = response;
            this.listaKpi = this.formatearObjetoKpi(resp);
            console.log('LISTA KPI');
            console.log(this.listaKpi);
            console.log(this.listaKpi.length);
            $("#btnBuscarCapacitacion").prop("disabled", false);
            this.iconBtnBuscarCapacitacion = false;
        })
            .catch(error => {
            $("#btnBuscarCapacitacion").prop("disabled", false);
            this.iconBtnBuscarCapacitacion = false;
            error = true;
        });
    }
    formatearObjetoKpi(lista) {
        let listaKpi = [];
        let listaRefuerzo = [];
        let total = 0;
        for (let i = 0; i < lista.length; i++) {
            let cantidad_base = lista[i][3];
            let ponderacion_base = lista[i][4];
            let cantidad = lista[i][5];
            let ponderacion = Math.round((cantidad * ponderacion_base) / cantidad_base);
            if (ponderacion > ponderacion_base) {
                ponderacion = ponderacion_base;
            }
            if (ponderacion < ponderacion_base) {
                if (lista[i][1] == 'NA') {
                    listaRefuerzo.push(lista[i][2]);
                }
                else {
                    listaRefuerzo.push(lista[i][1]);
                }
            }
            i;
            let kpi = {
                proceso: lista[i][0],
                foco: lista[i][1],
                categoria: lista[i][2],
                cantidad_base: cantidad_base,
                ponderacion_base: ponderacion_base,
                cantidad: cantidad,
                ponderacion: ponderacion,
            };
            total += ponderacion;
            listaKpi.push(kpi);
            this.porcentajeMinimodeAprobacion += ponderacion;
        }
        this.listRefuerzoAreas = listaRefuerzo;
        console.log(this.listRefuerzoAreas);
        this.estado.porcentaje = total;
        return listaKpi;
    }
    buscarReforzamiento(idPlan) {
        this.capacitaciones.getRefuerzoCapacitacion(idPlan)
            .then(response => {
            let resp = response;
            this.listRefuerzo = resp;
            // this.buscarStatus(this.estado.porcentaje);
            this.mostrarEstado(this.estado.porcentaje);
            $("#btnBuscarCapacitacion").prop("disabled", false);
            this.iconBtnBuscarCapacitacion = false;
        })
            .catch(error => {
            $("#btnBuscarCapacitacion").prop("disabled", false);
            this.iconBtnBuscarCapacitacion = false;
            error = true;
        });
    }
    mostrarEstado(porcentaje) {
        if (porcentaje >= 85) {
            this.estado.estado = "Aprobado";
            this.estado.color = "green";
        }
        else if (porcentaje >= 70 && porcentaje < 85) {
            this.estado.estado = "Reforzamiento";
            this.estado.color = "orange";
        }
        else {
            this.estado.estado = "Rechazado";
            this.estado.color = "red";
        }
        this.estado.porcentaje = porcentaje;
    }
    buscarStatus(porcentaje) {
        this.capacitaciones.getStatusCapacitacion(porcentaje)
            .then(response => {
            let resp = response;
            this.listStatus = resp;
        })
            .catch(error => {
            error = true;
        });
    }
    removeDuplicates(data, key) {
        return [
            ...new Map(data.map(item => [key(item), item])).values()
        ];
    }
    ;
    collapseKPI() {
        this.isKpiCollapsed = !this.isKpiCollapsed;
    }
    evaluarCantidad(kpi, valorComprarable) {
        if (Number(kpi) <= Number(valorComprarable)) {
            return true;
        }
        else if (Number(kpi) > Number(valorComprarable)) {
            return false;
        }
    }
    //Apertura Modales
    openSm(content, accion, modalOrigen) {
        this.accion = accion;
        if (accion === 'cancelacion' && (this.observacionCancelacion == null || this.observacionCancelacion.trim() === "")) {
            this.mensaje = "La observación no puede ser vacía";
            this.errorModal = true;
        }
        else if (accion === 'rechazar' && (this.observacionRechazo == null || this.observacionRechazo.trim() === "")) {
            this.mensaje = "La observación no puede ser vacía";
            this.errorModal = true;
        }
        else if (accion === "actualizacion" && (isNaN(this.realAssistance) || this.realAssistance == 0 || (this.horaCapacitacion === null || this.horaCapacitacion.trim() === "")
            && this.model === null)) {
            this.mensaje = "No es posible realizar la actualización de la capacitación sin especificar las horas y la fecha de capacitación o sin asigar al menos un asistente.";
            this.errorModal = true;
        }
        else {
            this.errorModal = false;
            this.modalService.dismissAll(modalOrigen);
            this.modalService.open(content, { size: 'sm' });
        }
    }
    open(content, type, element) {
        this.errorModal = false;
        if (type == "cancel") {
            this.datosCancelacion(element);
        }
        else if (type == "aprobacion") {
            this.datosModal(element);
            this.realAssistance = 0;
            this.workersRows = [];
            this.model = null;
            this.evidences = [];
        }
        else if (type == "evidencia") {
            this.listAdjuntos = [];
            this.modCapacitacionId = element;
            this.nombreAdjuntos(element);
        }
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    }
    //Ejecutar acciones - Modal de Confirmación
    ejecutarAccion() {
        if (this.accion == "cancelacion") {
            this.cancelacionCapacitacion();
        }
        else if (this.accion == "rechazar") {
            this.rechazarIcon = true;
            this.cambioEstadoPlan('rechazado');
        }
        else if (this.accion == "actualizacion") {
            this.guardarInformacion();
        }
        else if (this.accion == "aprobar") {
            this.aprobarIcon = true;
            this.cambioEstadoPlan('aprobado');
        }
        this.accion = "";
        this.modalService.dismissAll('Successfully created Goal');
    }
    //Cambio Estado Campos Modal
    changeInput(campo, value) {
        if (campo == "rechazo") {
            this.observacionRechazo = value;
        }
        else if (campo == "horaCapacitacion") {
            this.horaCapacitacion = value;
        }
        else if (campo == "cancelacion") {
            this.observacionCancelacion = value;
        }
    }
    //Obtener datos para modal
    datosModal(capacitaciones) {
        this.modCapacitacionId = capacitaciones.capacitacionId;
        this.modNombreCapacitacion = capacitaciones.name;
        this.modIdPlan = capacitaciones.planCapacitacionId;
        this.modPlanCapacitacion = capacitaciones.planCapacitacion;
        this.modNombreContratista = capacitaciones.nombreContratista;
        this.modZona = capacitaciones.zoneDescription;
        this.modCategoria = capacitaciones.categoryDescription;
        this.modFoco = capacitaciones.focoDescription;
        this.modEnfoque = capacitaciones.enfoqueDescription;
        this.modEjecutor = capacitaciones.ejecutorDescription;
        this.modFecha = capacitaciones.fecha;
    }
    datosCancelacion(capacitaciones) {
        this.cancCapacitacionId = capacitaciones.capacitacionId;
    }
    //Obtener y Descargar Adjuntos
    nombreAdjuntos(capacitacion) {
        this.aprobacionService.getArchivosAdjuntos(capacitacion)
            .then(response => {
            this.listAdjuntos = response;
        })
            .catch(error => {
            error = true;
            this.listAdjuntos = [];
        });
    }
    descargar(adjuntos) {
        this.aprobacionService.getDownloadFile(this.modCapacitacionId, adjuntos)
            .subscribe(blob => saveAs(blob, adjuntos));
    }
    //ACCIONES - Cancelación Capacitacion
    cancelacionCapacitacion() {
        this.aprobacionService.cancelacionCapacitacion(this.cancCapacitacionId, this.observacionCancelacion, sessionStorage.getItem('userid'))
            .then(response => {
            this.buscarCapacitacionesFiltradas();
        })
            .catch(error => {
            this.error = true;
            this.mensaje = "Ha ocurrido un error en la inserción, comuniquese con el administrador";
        });
        setTimeout(function () {
            document.getElementById("divMensaje").style.display = 'none';
        }, 5000);
    }
    //Sort elementos de la tabla
    sort(headerName) {
        if (this.orderHeader === headerName) {
            this.reverse = !this.reverse;
        }
        else {
            this.orderHeader = headerName;
        }
        if (headerName === "planCapacitacionId") {
            this.planIdHabilitado = true;
            this.planHabilitado = this.capacitacionHabilitado = this.contratistaHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "planCapacitacion") {
            this.planHabilitado = true;
            this.planIdHabilitado = this.capacitacionHabilitado = this.contratistaHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "name") {
            this.capacitacionHabilitado = true;
            this.planIdHabilitado = this.planHabilitado = this.contratistaHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "nombreContratista") {
            this.contratistaHabilitado = true;
            this.planIdHabilitado = this.planHabilitado = this.capacitacionHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "zoneDescription") {
            this.zonaHabilitado = true;
            this.planIdHabilitado = this.planHabilitado = this.capacitacionHabilitado = this.contratistaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "categoryDescription") {
            this.categoriaHabilitado = true;
            this.planIdHabilitado = this.planHabilitado = this.capacitacionHabilitado = this.contratistaHabilitado = this.zonaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "focoDescription") {
            this.focoHabilitado = true;
            this.planIdHabilitado = this.planHabilitado = this.capacitacionHabilitado = this.contratistaHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.enfoqueHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "enfoqueDescription") {
            this.enfoqueHabilitado = true;
            this.planIdHabilitado = this.planHabilitado = this.capacitacionHabilitado = this.contratistaHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.ejecutorHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "ejecutorDescription") {
            this.ejecutorHabilitado = true;
            this.planIdHabilitado = this.planHabilitado = this.capacitacionHabilitado = this.contratistaHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.fechaHabilitado = false;
        }
        else if (headerName === "fecha") {
            this.fechaHabilitado = true;
            this.planHabilitado = this.planIdHabilitado = this.contratistaHabilitado = this.capacitacionHabilitado = this.zonaHabilitado = this.categoriaHabilitado =
                this.focoHabilitado = this.enfoqueHabilitado = this.ejecutorHabilitado = false;
        }
    }
    //Acciones Modal de Aprobación de Capacitacion - busqueda de trabajadores y carga de evidencia
    canAssignWorkers() {
        return true;
    }
    openPronexoModal(modal) {
        const request = this.modIdPlan;
        this.capacitacionSelected = request;
        this.openModal(modal, { size: 'lg' });
    }
    openModal(modal, options = {}) {
        this.modalService.open(modal, Object.assign({ ariaLabelledBy: 'modal-basic-title' }, options));
    }
    onWorkersSelectedChange(workersIdSelected, workersSelected) {
        this.workersIdSelected = workersIdSelected;
        this.workersSelected = workersSelected;
        this.workersRows = workersSelected.map(worker => this.buildWokerRow(worker));
        this.realAssistance = this.workersRows.length;
    }
    buildWokerRow(worker) {
        return {
            id: worker.rutTrabajador,
            worker,
            cells: [
                { class: 'td-centered', tooltip: false, content: worker.rutTrabajador },
                { class: 'td-centered', tooltip: false, content: worker.nombreTrabajador },
                { class: 'td-centered', tooltip: false, content: worker.apellidoPaterno },
                { class: 'td-centered', tooltip: false, content: worker.apellidoMaterno }
            ]
        };
    }
    removeWorker(worker) {
        const idIndex = this.workersIdSelected.findIndex(id => id === worker.rutTrabajador);
        const workerIndex = this.workersSelected.findIndex(workerToAdd => workerToAdd.rutTrabajador === worker.rutTrabajador);
        const rowIndex = this.workersRows.findIndex(row => row.id === worker.rutTrabajador);
        this.workersIdSelected.splice(idIndex, 1);
        this.workersSelected.splice(workerIndex, 1);
        this.workersRows.splice(rowIndex, 1);
        this.realAssistance = this.workersRows.length;
    }
    uploadFile(event, formDirective, archivo) {
        const file = event.target.files[0];
        this.form.patchValue({
            evidenceFile: file
        });
        this.form.get('evidenceFile').updateValueAndValidity();
        if (this.form.value.evidenceFile != null) {
            const formData = new FormData();
            formData.append('file', this.form.value.evidenceFile, this.form.value.evidenceFile.name);
            formDirective.resetForm();
            this.form.reset();
            let cap = 0;
            this.evidenciaService.uploadTemp(this.uuid == "" ? null : this.uuid, formData).then((data) => {
                this.uuid = data.resultado;
                this.idsAdjuntos.push(this.uuid);
                this.fetchEvidenciaTemp();
            }).catch((error) => {
                this.errorMessage = error.error.message.includes("Maximum upload size exceeded") ? 'Error al guardar, archivo excede el límite definido.' : 'Error';
            });
        }
        else {
            this.error = true;
            this.errorMessage = 'Error al guardar, debe ingresar un archivo.';
        }
        archivo.value = "";
    }
    fetchEvidenciaTemp() {
        this.evidenciaService.listTemp(this.uuid)
            .then(evidencias => {
            this.evidences = evidencias.evidencias;
            if (this.evidences.length > 0) {
                this.listClass = true;
            }
        })
            .catch(error => {
            console.error(error);
        });
    }
    calculeSvgIcon(file) {
        const fileExt = file.split(".");
        let svg = "";
        switch (fileExt[fileExt.length - 1]) {
            case "jpg":
                svg = 'assets/icons/jpg_format.svg';
                break;
            case "png":
                svg = 'assets/icons/png_format.svg';
                break;
            case "zip":
                svg = 'assets/icons/zip_format.svg';
                break;
            case "rar":
                svg = 'assets/icons/rar_format.svg';
                break;
            case "ppt":
                svg = 'assets/icons/ppt_format.svg';
                break;
            case "pptx":
                svg = 'assets/icons/ppt_format.svg';
                break;
            case "pdf":
                svg = 'assets/icons/pdf_format.svg';
                break;
            case "xls":
                svg = 'assets/icons/excel_black.svg';
                break;
            case "xlsx":
                svg = 'assets/icons/excel_black.svg';
                break;
            case "doc":
                svg = 'assets/icons/word.svg';
                break;
            case "docx":
                svg = 'assets/icons/word.svg';
                break;
            default:
                svg = 'assets/icons/text_format.svg';
                break;
        }
        return svg;
    }
    downloadFile(id, name) {
        this.evidenciaService.downloadFile(id, name);
    }
    deleteFile(id) {
        this.evidenciaService.delete(id).then(res => {
            this.fetchEvidenciaTemp();
        })
            .catch(error => console.error(error));
    }
    guardarInformacion() {
        this.updateCapacitacion();
    }
    saveEvidence(url) {
        this.evidenciaService.saveTemp(url, this.modCapacitacionId).then((data) => {
        }).catch((error) => {
            console.log(error);
        });
    }
    updateCapacitacion() {
        this.aprobacionService.updateCapacitacion(this.modCapacitacionId, this.horaCapacitacion, String(this.model), this.workersIdSelected, this.modFecha)
            .then(response => {
            for (let url of this.idsAdjuntos) {
                this.saveEvidence(url);
            }
            this.buscarCapacitacionesFiltradas();
        })
            .catch(error => {
            error = true;
        });
    }
}
